module.exports = __webpack_public_path__ + "static/media/HCMM713.27ee8a05.jpg";